export const GtmEventTypes = {
  USER_PROFILE_INIT: 'USER_PROFILE_INIT',
};

export const GtmVariables = {
  EMAIL: 'email',
};
